import $http from '../api/http'

const groupMessages = {
  // 批量发送短信
  async sendMessages (data) {
    return $http('/api/messages/file', {
      method: 'POST',
      data: data
    });
  },
  async asyncMessages (data) {
    return $http('/api/messages/async', {
      method: 'POST',
      data: data
    });
  },
  async sendMms (data) {
    return $http('/api/mms/messages/mult', {
      method: 'POST',
      data: data
    });
  }
};

export default groupMessages;



// WEBPACK FOOTER //
// ./src/api/groupMessages.js